export const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
